<template>
  <section id="service" class="n2-seccion n2-seccion--suave" v-if="S?.Mostrar && servicios.length">
    <div class="n2-contenedor">
      <div class="n5-cabeza n2-aparece">
        <div>
          <span v-if="etiqueta" class="n5-etiqueta">{{ etiqueta }}</span>
          <h2 class="n5-titulo"><NuxtLink :to="getLocalePath('/servicios')"><span v-html="S.Titulo?.Texto || porDefecto"></span></NuxtLink></h2>
          <div v-if="S.Descripcion?.Texto" class="n2-entradilla" :style="alineacionTexto(S.Descripcion.css)" v-html="S.Descripcion.Texto"></div>
        </div>
        <NuxtLink v-if="S.ShowButton && S.Button?.Texto" class="n2-enlace" :to="getLocalePath('/servicios')">{{ S.Button.Texto }} <span aria-hidden="true">→</span></NuxtLink>
      </div>

      <div class="n5-servicios__rejilla">
        <article v-for="(s, i) in servicios" :key="s.id ?? i" class="n5-servicio n2-aparece">
          <img v-if="s.Imagen" class="n5-servicio__foto" :src="imagenIDtoSRC(s.Imagen)" alt="" loading="lazy" />
          <span v-else class="n5-servicio__num" aria-hidden="true">{{ String(i + 1).padStart(2, '0') }}</span>
          <h3><NuxtLink :to="getLocalePath('/servicios/' + s.Slug) + '?from=home'">{{ s.Titulo }}</NuxtLink></h3>
          <p>{{ textoPlano(s.Extracto || s.Subtitulo || s.Contenido, 140) }}</p>
          <div class="n5-servicio__pie">
            <span>{{ tSolicitud('Más información') }} →</span>
            <NuxtLink v-if="acceso.visible('servicios') && acceso.tramiteDeServicio(s)" :to="acceso.enlace('servicios', acceso.tramiteDeServicio(s))"
              class="n2-boton n2-boton--acento">{{ tSolicitud('Hacerlo online') }}</NuxtLink>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, textoPlano, alineacionTexto } from '../../composables/useNotaria2'
import { etiquetaSeccion } from '../../composables/useNotaria5'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
const acceso = useAccesoSolicitud()

// Panel: Inicio → Servicios y los servicios marcados "Mostrar en inicio"
const S = computed(() => NOTARIA.value?.Theme?.Home?.Servicios)
const servicios = computed(() => (NOTARIA.value?.Servicios ?? []).filter(s => s.Publicado && s.MostrarHome))
const porDefecto = computed(() => tituloSeccion(NOTARIA.value, 'Servicios', $t))
const etiqueta = computed(() => etiquetaSeccion(S.value?.Titulo?.Texto, porDefecto.value))
</script>
